import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["trigger", "content"];

  initialize() {
    this.initPopup();
    this.contentTarget.style.display = "none";
  }

  initPopup() {
    tippy(this.triggerTarget, {
      content: this.contentTarget.innerHTML,
      allowHTML: true,
      theme: "mydefault",
      maxWidth: "210px",
      minWidth: "0px",
      placement: "bottom",
    });
  }
}
